import { RouteRecordRaw } from "vue-router";
import { LoginRoutesConst } from "src/const/routesConst";
import { useSettingStore } from "stores/useSettingStore";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("layouts/LayoutsIndex.vue"),
    children: [
      {
        path: "/",
        redirect: "/dashboard-d", // 기본 진입 경로를 대시보드로 리디렉트
      },
      {
        path: "/dashboard-d",
        name: LoginRoutesConst.DashboardD,
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/Dashboard.vue"
          ),
        beforeEnter: (to, from, next) => {
          const settingStore = useSettingStore();
          settingStore.setSetting({ currentDType: "D" });
          next();
        },
      },
      {
        path: "/dashboard-a",
        name: LoginRoutesConst.DashboardA,
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/Dashboard.vue"
          ),
        beforeEnter: (to, from, next) => {
          const settingStore = useSettingStore();
          settingStore.setSetting({ currentDType: "A" });
          next();
        },
      },
      {
        path: "/retention",
        name: LoginRoutesConst.Retention,
        component: () =>
          import(
            /* webpackChunkName: "views-Dashboard" */ "pages/Retention.vue"
          ),
        meta: {
          accessRole: [255, 245],
        },
      },
      {
        path: "/resource",
        name: LoginRoutesConst.ResourceManagement,
        component: () =>
          import(
            /* webpackChunkName: "views-ResourceManagement" */ "pages/resource/ResourceManagement.vue"
          ),
        meta: {
          accessRole: [255],
        },
      },
      {
        path: "/audit-logs",
        name: LoginRoutesConst.AuditLog,
        component: () =>
          import(
            /* webpackChunkName: "views-AuditLog" */ "pages/audit/AuditLogManagement.vue"
          ),
        meta: {
          accessRole: [255],
        },
      },
      {
        path: "/audio-studio",
        name: LoginRoutesConst.AudioStudio,
        component: () =>
          import(
            /* webpackChunkName: "views-AudioStudio" */ "pages/audioStudio/AudioStudioManagement.vue"
          ),
        meta: {
          accessRole: [255],
        },
      },
      {
        path: "/patients-d/:patientUUID",
        name: LoginRoutesConst.PatientD,
        component: () =>
          import(
            /* webpackChunkName: "views-Patient" */ "pages/Dashboard/Patient.vue"
          ),
        props: true,
      },
      {
        path: "/patients-a/:patientUUID",
        name: LoginRoutesConst.PatientA,
        component: () =>
          import(
            /* webpackChunkName: "views-Patient" */ "pages/Dashboard/AphasiaPatient.vue"
          ),
        props: true,
      },

      {
        path: "/user/profile",
        name: LoginRoutesConst.UserProfile,
        component: () =>
          import(
            /* webpackChunkName: "views-UserProfile" */ "pages/user/UserProfile.vue"
          ),
      },
      {
        path: "/user/list",
        name: LoginRoutesConst.UserList,
        component: () =>
          import(
            /* webpackChunkName: "views-UserList" */ "pages/user/UserList.vue"
          ),
      },
      {
        path: "/user/add",
        name: LoginRoutesConst.UserAdd,

        component: () =>
          import(
            /* webpackChunkName: "views-UserAdd" */ "pages/user/UserAdd.vue"
          ),
      },
      {
        path: "/user/logout",
        name: LoginRoutesConst.UserLogout,
        component: () =>
          import(
            /* webpackChunkName: "views-Profile" */ "pages/user/UserLogout.vue"
          ),
      },
    ],
  },

  {
    path: "/temp",
    name: "temp",
    component: () =>
      import(/* webpackChunkName: "views-temp" */ "pages/temp.vue"),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/ErrorNotFound.vue"),
  },
];

export default routes;
